import React, { createContext, useState } from "react";

export enum MessageType {
  success,
  warn,
  danger,
}

export type Message = {
  type: MessageType;
  msg: string;
  active: boolean;
  id: number;
};

const MessageContextDefaultValues: {
  activeMessages: Message[];
  addMessage: (msg: string, type: MessageType) => void;
} = {
  activeMessages: [],
  addMessage: (msg: string, type: MessageType) => {},
};

export const MessageContext = createContext(MessageContextDefaultValues);

//create your forceUpdate hook
function useForceUpdate() {
  const [, setValue] = useState(0); // integer state
  return () => setValue((value) => ++value); // update the state to force render
}

export const MessageContextProvider: React.FC = ({ children }) => {
  const [messages, setMessages] = useState<Message[]>([]);
  const [id, setId] = useState(0);
  const forceUpdate = useForceUpdate();

  const addMessage = (msg: string, type: MessageType) => {
    const newMessage = { msg, type, active: true, id: id };
    setId(id + 1);

    setMessages([...messages, newMessage]);
    setTimeout(() => {
      newMessage.active = false;
      forceUpdate();
    }, 7000);
  };

  return (
    <MessageContext.Provider
      value={{ activeMessages: messages.filter((m) => m.active), addMessage }}
    >
      {children}
    </MessageContext.Provider>
  );
};
